import LinkWrapper from '../../LinkWrapper';
import BetaChip from '../../../components/BetaChip';
import NoveltyChip from '../../../components/NoveltyChip';

interface SidebarItemProps {
    caption: string;
    href?: string;
    isActive: boolean;
    onClick: () => void;
    icon?: React.ReactNode;
    /** Ancla para el tour guiado. */
    id?: string;
    /** Marca la entrada como beta. */
    beta?: boolean;
    /** Marca la entrada como novedad («Nuevo»). */
    novelty?: boolean;
}

/**
 * Ítem de primer nivel del sidebar. Mismo tratamiento visual que
 * sporttia-competitions: relleno verde oliva y texto verde marca cuando está
 * activo, realce neutro al pasar por encima.
 */
export default function SidebarItem({
    caption,
    href,
    isActive,
    onClick,
    icon,
    id,
    beta = false,
    novelty = false,
}: SidebarItemProps): React.ReactElement {
    return (
        <li id={id}>
            <LinkWrapper href={href} callback={onClick}>
                <span
                    className={`flex h-8 w-full items-center gap-2 rounded-md p-2 text-sm transition-colors ${
                        isActive
                            ? 'bg-sidebar-active text-sidebar-active-foreground font-medium'
                            : 'text-sidebar-foreground hover:bg-sidebar-accent hover:text-sidebar-accent-foreground'
                    }`}
                >
                    {icon}
                    <span className="truncate">{caption}</span>
                    {beta && <BetaChip />}
                    {novelty && <NoveltyChip />}
                </span>
            </LinkWrapper>
        </li>
    );
}
